/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGATrackEvent } from '@app/analytics';
import { useIsNonInteractiveViewer } from '@app/ui';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import AboutMenu from '../../menu/AboutMenu';
import { AboutNavItemWrapper } from './About.styles';

const About = () => {
  const urlPrefix = useUrlPrefix();
  const { t } = useTranslation();
  const gaTrackEvent = useGATrackEvent();
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const [aboutNavRendered, setAboutNavRendered] = useState(
    isNonInteractiveViewer,
  );

  return (
    <AboutNavItemWrapper
      data-testid="navbar-menu-about"
      onClick={() => {
        gaTrackEvent('Top Navigation About Clicked', 'All', 'About');
      }}
      onMouseEnter={() => setAboutNavRendered(true)}
    >
      <a
        data-testid="navbar-menu-about-link"
        href={`https://stockx.com/about${urlPrefix}how-it-works/`}
      >
        {t('About')}
      </a>
      {aboutNavRendered && <AboutMenu format={'dropdown'} />}
    </AboutNavItemWrapper>
  );
};

export default About;
